import { Checkbox, Tooltip } from 'bold-ui'
import { Action } from 'graphql/types.generated'
import { ChangeEvent } from 'react'

import { disabledAction, validAction } from '../../reterritorializacao/utils/reterritorializacao'
import {
  InativacaoImovelItemModel,
  ItemActionParams,
  MAXIMUM_INATIVACAO_IMOVEIS_SIZE,
} from '../model-inativacaoImoveis'
import { getPermissionInativarImovelAction } from '../utils/utils-inativacaoImoveis'

interface InativacaoImoveisCheckItemProps {
  item: InativacaoImovelItemModel
  checkedItems: Set<string>
  setCheckedItems: (items: Set<string>) => void
  disabled?: boolean
}

export function InativacaoImoveisCheckItem({
  item,
  checkedItems,
  setCheckedItems,
  disabled,
}: Readonly<InativacaoImoveisCheckItemProps>) {
  const handleCheck = (event: ChangeEvent<HTMLInputElement>, imovelId: string) => {
    const newCheckedItems = new Set(checkedItems)
    event.target.checked ? newCheckedItems.add(imovelId) : newCheckedItems.delete(imovelId)
    setCheckedItems(newCheckedItems)
  }

  const itemAction = getItemAction({
    disabled,
    checkedItems,
    item,
  })

  return (
    <Tooltip text={itemAction.hint ?? ''}>
      <div>
        <Checkbox
          onChange={(event) => handleCheck(event, item.id)}
          checked={checkedItems.has(item.id)}
          disabled={!itemAction.enabled}
        />
      </div>
    </Tooltip>
  )
}

const maxCheckedActionInativacao = (): Action => ({
  enabled: false,
  hint: `Seleção bloqueada. Por razões de segurança você pode inativar até ${MAXIMUM_INATIVACAO_IMOVEIS_SIZE} imóveis por vez.`,
})

const getMaximumCheckedActionInativacao = (checkedItems: Set<string>, imovelDto: InativacaoImovelItemModel): Action =>
  checkedItems.size >= MAXIMUM_INATIVACAO_IMOVEIS_SIZE && !checkedItems.has(imovelDto.id)
    ? maxCheckedActionInativacao()
    : validAction

const getItemAction = ({ disabled, checkedItems, item }: ItemActionParams): Action => {
  if (disabled) return disabledAction

  const permissionAction = getPermissionInativarImovelAction(item)
  if (!permissionAction.enabled) return permissionAction

  return getMaximumCheckedActionInativacao(checkedItems, item)
}
